import type { CustomerRevenueReport } from '@weft/types';
import type { Column, Workbook } from 'exceljs';
import { formatCustomerRevenueReport } from '../customer-revenue-excel-formatter';
import { getTotalCustomerRevenueDateHeaders } from '../get-total-revenue-dates';

const REVENUE_REPORT_WORKSHEET_STATIC_HEADERS = Object.freeze([
  { key: 'customerName', header: 'Customer name' },
  { key: 'contractStartDate', header: 'Contract start date' },
  { key: 'contractEndDate', header: 'Contract end date' },
  { key: 'productName', header: 'Product' },
  { key: 'pricingType', header: 'Pricing type' },
  { key: 'emptySpace1', header: '' },
  { key: 'billedUnbilled', header: 'Billed / Unbilled' },
]);

export function createRevenueReportWorksheet(workbook: Workbook, revenueReport: CustomerRevenueReport) {
  const worksheet = workbook.addWorksheet('Report');

  const formattedData = formatCustomerRevenueReport(revenueReport);

  const dynamicHeaders = getTotalCustomerRevenueDateHeaders(revenueReport.reportItems);

  worksheet.columns = getRevenueColumns(dynamicHeaders);
  worksheet.getRow(1).font = { bold: true };
  formattedData.forEach((rowData) => {
    const row = worksheet.addRow(rowData.map((item) => item.value));

    rowData.forEach((cellData, index) => {
      row.getCell(index + 1).border = cellData.border ?? {};
      row.getCell(index + 1).font = cellData.font ?? {};
    });

    row.commit();
  });
}

function getRevenueColumns(dynamicHeaders: string[]): Partial<Column>[] {
  return [
    ...REVENUE_REPORT_WORKSHEET_STATIC_HEADERS.map<Partial<Column>>((header) => ({
      header: header.header,
      key: header.key,
      width: 20,
    })),
    ...dynamicHeaders.map<Partial<Column>>((header) => ({
      header,
      key: header,
      width: 15,
    })),
  ];
}